import _ from 'lodash';
import React,{Component} from 'react';
import {connect} from 'react-redux';
import {isEmpty} from 'BaseFunctions';
import {ComposedChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend, PieChart, Pie, Cell, Sector,
  Label, LabelList} from 'recharts';
import moment from 'moment';
import {scaleOrdinal,schemeCategory10,schemeCategory20,schemeCategory20b,schemeCategory20c} from 'd3-scale';
import {fetchSessionAnalytics} from 'DashboardSessionAction';
import SessionListItem from './session-list-item';
import PaginationComponent from 'PaginationComponent';
import {isTablet} from 'Constants';
import LocaleStrings from 'Languages';

var randomColor = require('randomcolor');

class DashboardSession extends Component {

  constructor(props){
  	super(props);
    var randomColors=this.generateColors();//[...scaleOrdinal(schemeCategory20).range(),...scaleOrdinal(schemeCategory20b).range(),...scaleOrdinal(schemeCategory20c).range()];

  	this.state = {colors:randomColors,paginatedData:[],selectedPage: 0};
  }

  generateColors = () =>{
    var randomColors=[];//[...scaleOrdinal(schemeCategory20).range(),...scaleOrdinal(schemeCategory20b).range(),...scaleOrdinal(schemeCategory20c).range()];
    for(var i=0;i<200;i++){
      randomColors.push(randomColor());
    }
    randomColors=[...randomColors,...randomColor({hue: 'red', count: 50}),...randomColor({hue: 'orange', count: 50}),...randomColor({hue: 'blue', count: 50}),...randomColor({hue: 'green', count: 50}),randomColor({hue: 'yellow', count: 50}),...randomColor({hue: 'purple', count: 50}),...randomColor({hue: 'pink', count: 50}),...randomColor({luminosity: 'dark', count: 50})];
    randomColors=_.shuffle(randomColors);
    randomColors=_.shuffle(randomColors);
    randomColors=_.shuffle(randomColors);

    return randomColors;
  }

  componentDidMount() {
    setTimeout(()=>{
        this.getPaginatedItems();
    },300);
  }

  renderSessionList() {
    return _.map(this.state.paginatedData, data => {
      return <SessionListItem key={data.screen} data={data}/>;
    });
  }

  getPaginatedItems = (page) => {
    // debugger;
    var items=this.props.sessions.screenData;
    var page = page || 1,
    per_page = 5,
    offset = (page - 1) * per_page,
    paginatedItems = _.drop(items, offset).slice(0, per_page);

    this.setState({paginatedData:paginatedItems});
  }

  renderPaginationList=()=> {
    var callback = (pageNumber) => {
      if (this.state.selectedPage !== pageNumber) {
        this.setState({selectedPage:pageNumber});
        this.getPaginatedItems(pageNumber+1);
      }
    }
    var pageCount = Math.floor(this.props.sessions.screenData.length / 5) + 1;
    var paginationItems = [];
    for(var pageNumber = 0; pageNumber < pageCount; pageNumber++) {
      var isactive=(this.state.selectedPage === pageNumber);
      paginationItems.push(<PaginationComponent key={pageNumber} active={isactive} pageNumber={pageNumber} callback={callback}/>);
    }
    return paginationItems;
  }


    render() {
        var {screenData,todaysScreenData}=this.props.sessions;
        var pieVersion=[];
  
      

        if(todaysScreenData){
          pieVersion=todaysScreenData;
        }

        var pageCount = 0;

        if(screenData && screenData.length>0){
          pageCount=Math.floor(screenData.length / 5) + 1;
        }

        var firstColCss="col-md-5 col-xs-12 col-lg-5";
        var secondColCss="col-md-7 col-xs-12 col-lg-7";

        if(isTablet){
          firstColCss="col-md-12 col-xs-12 col-lg-12";
          secondColCss="col-md-12 col-xs-12 col-lg-12";
        }

        return (
          <div className="row">
            <div className={firstColCss}>
              <div className="panel panel-default dashboard-panel">
                <div className="panel-heading dashboard-panel-head" style={{borderColor:'white'}}>
                    <div className="pull-left text-capitalize dashboard-content-heading">
                      {LocaleStrings.sessions}{' '}{LocaleStrings.analytics_sessions_chart_subheader}
                    </div>
                </div>
                {!isEmpty(pieVersion)?
                  <div className="panel-body dashboard-session-graph-panel ">
                    <div className="device-percentage">
                      <span style={{fontSize:24}}>{pieVersion.length}</span><span style={{fontSize:14}}> {LocaleStrings.sessions}</span>
                    </div>
                    <PieChart width={500} height={220}>
                      <Pie data={pieVersion}
                        outerRadius={80}
                        innerRadius={50}
                        dataKey="value"
                        labelLine={false}
                        legendType='circle'
                        >
                        {
                          pieVersion.map((entry, index) =><Cell key={`slice-${index}`} fill={this.state.colors[index]}/>)
                        }
                      </Pie>
                      <Tooltip/>
                      <Legend iconSize={5}  wrapperStyle={{ right:'40px',top:0,height:'280px',overflow:'auto',width:'220px',fontSize:11 }} layout='vertical' verticalAlign='middle' align="right"/>
                    </PieChart>
                  </div>
                  :<div className="nouser-info"><span>{LocaleStrings.analytics_text_no_session_recorded_yet}</span></div>
                  
                }
              </div>
            </div>
            <div className={secondColCss}>
              <div className="panel panel-default">
                <div className="panel-heading dashboard-panel-head" style={{borderColor:'white'}}>
                  <p className="text-capitalize dashboard-content-heading">{LocaleStrings.analytics_text_session_details}</p>
                </div>
                {(screenData && screenData.length>0)?
                <div className="sessions-table">
                  <table className="table">
                      <thead>
                        <tr>
                          <th>{LocaleStrings.analytics_table_list_screen_name}</th>
                          <th>{LocaleStrings.analytics_table_list_hits}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.renderSessionList()}
                      </tbody>
                  </table>
                  {
                      (pageCount<=1)?null:
                      <div className="pull-right" style={{marginTop:10}}>
                        <ul className="pagination">
                          {this.renderPaginationList()}
                        </ul>
                      </div>
                  }
                </div>
                :<div className="nouser-info"><span>{LocaleStrings.analytics_text_no_session_recorded_recently}</span></div>
              }
              </div>
            </div>
          </div>
        );
    }
}

function mapStateToProps(state){
  return{
    session: state.session
  }
}

export default connect(mapStateToProps, {fetchSessionAnalytics}) (DashboardSession);
